import React from 'react';

import { FormikCheckbox } from '~commonInfra/components/FormikCheckbox';
import { MetadataDrivenSiteSettings } from '~commonInfra/components/MetadataDrivenSiteSetting';
import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';

import { Messages } from '../../../../../codegen/Localize';
import { SettingsSection } from '../../../../components/common/SettingsSection';
import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';
import { SiteSettingsForSiteAdminProps } from '../../site-settings/ReactSiteSettingsForSiteAdmin';

export const COLLECTIONS_SETTING = 'collectionsEnabled';
export const COLLECTIONS_SECTION_NAME = 'collections';
export const COLLECTIONS_SECTION_FORMIK_PREFIX = 'settings';
export const COLLECTIONS_SECTION_TEST_ID = 'collections-setting-section';
export const COLLECTIONS_ENABLED_CHECKBOX_TEST_ID = 'collections-enabled';

export type CollectionsSettingSectionProps = SiteSettingsForSiteAdminProps<typeof COLLECTIONS_SETTING>;

export function CollectionsSettingSection(): React.ReactElement {
  if (FeatureFlags.metadataDrivenSiteSettingsEnabled) {
    return (
      <SettingsSection
        title={Messages.collections()}
        testId={COLLECTIONS_SECTION_TEST_ID}>
        <MetadataDrivenSiteSettings
          sectionName={COLLECTIONS_SECTION_NAME}
          formikPrefix={COLLECTIONS_SECTION_FORMIK_PREFIX} />
      </SettingsSection>
    );
  }

  return (
    <SettingsSection
      description={Messages.collectionsSiteSettingDescription()}
      title={Messages.collections()}
      testId={COLLECTIONS_SECTION_TEST_ID}>
      <FormikCheckbox
        label={Messages.collectionsSiteSettingLabel()}
        name={`${COLLECTIONS_SECTION_FORMIK_PREFIX}.${COLLECTIONS_SETTING}`}
        testId={COLLECTIONS_ENABLED_CHECKBOX_TEST_ID}/>
    </SettingsSection>
  );
}

export const CollectionsSettingSectionSpecs = componentRegistryEntry({
  name: 'CollectionsSettingSection',
  component: CollectionsSettingSection
});